import styled from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import BaseIconButton from '@ublend-npm/aulaui-next-web/IconButton';

const IconButton = styled(BaseIconButton)`
  color: ${colors.designSystem.blackOpacity60};
  flex-shrink: 0;
  margin-left: 8px;

  display: flex;
  background-color: rgba(0, 0, 0, 0);
  &:hover {
    background-color: ${colors.designSystem.background.grey.hover};
  }
`;

export default IconButton;
